'use client';

import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Separator as SeparatorPrimitive } from 'radix-ui';
import { cn } from './lib/cn';
const separatorVariants = cva('shrink-0 data-[orientation=horizontal]:w-full data-[orientation=vertical]:self-stretch', {
  variants: {
    appearance: {
      stroke: 'border-0 bg-role-outline-subtle data-[orientation=horizontal]:h-px data-[orientation=vertical]:w-px',
      dashed: 'border-0 border-role-outline-subtle bg-transparent data-[orientation=horizontal]:h-0 data-[orientation=vertical]:w-0 data-[orientation=horizontal]:border-t data-[orientation=vertical]:border-l data-[orientation=horizontal]:border-dashed data-[orientation=vertical]:border-dashed'
    }
  },
  defaultVariants: {
    appearance: 'stroke'
  }
});
type SeparatorProps = React.ComponentProps<typeof SeparatorPrimitive.Root> & VariantProps<typeof separatorVariants>;
function Separator(t0) {
  const $ = _c(14);
  let appearance;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      appearance,
      decorative: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = appearance;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    appearance = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const decorative = t2 === undefined ? true : t2;
  let t3;
  if ($[6] !== appearance || $[7] !== className) {
    t3 = cn(separatorVariants({
      appearance
    }), className);
    $[6] = appearance;
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== decorative || $[10] !== orientation || $[11] !== props || $[12] !== t3) {
    t4 = <SeparatorPrimitive.Root className={t3} data-slot="separator" decorative={decorative} orientation={orientation} {...props} />;
    $[9] = decorative;
    $[10] = orientation;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export type { SeparatorProps };
export { Separator };